module.exports = __webpack_public_path__ + "img/2020_11_dande_moomin_fin_web.82adf9c2.jpg";